import { envConfig } from "@/config/env";
import type { HttpRequestOutcome } from "@/services/monitoring/network-debug-monitor/network-debug-monitor";
import { networkDebugMonitor } from "@/services/monitoring/network-debug-monitor/network-debug-monitor";
import { stripTrailingSlash } from "@/utils/url";

type ClaimAttemptLog = {
  measurementId: string;
  phoneNumber: string;
  introText?: string;
  outcome: HttpRequestOutcome;
  durationMs: number;
  status?: number;
  error?: string;
};

const SERVICE_NAME = "claim";

/**
 * Single entry point for logging a claim mutation attempt to the debug
 * console's network tab, from both the interactive claim call and the
 * offline queue flush. No-ops when the console is closed (via
 * networkDebugMonitor.logHttpRequest).
 */
export function logClaimAttempt(log: ClaimAttemptLog): void {
  const url = stripTrailingSlash(envConfig.graphqlBaseUrl) || "/graphql";

  networkDebugMonitor.logHttpRequest({
    service: SERVICE_NAME,
    method: "POST",
    url,
    status: log.status,
    durationMs: log.durationMs,
    error: log.error,
    requestBody: JSON.stringify({
      measurementId: log.measurementId,
      phoneNumber: log.phoneNumber,
      introText: log.introText,
    }),
    outcome: log.outcome,
  });
}
